export default {
    setLogin : (state, payload) => {
        state.isLogin = payload;
    },
    setHistory : (state, payload) =>{
        state.history = [];
        state.history.push(payload)
    },
    pushHistory : (state, payload) =>{
        state.history.push(payload)
    },
    setLnb : (state, payload) =>{
        state.lnb.loaded = true;
        state.lnb.category = payload
    },
    setscroll : (state) =>{
        state.scroll = Math.random() * 1000
    },
}
